var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _g3, _g4, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 571,
    height: 465,
    viewBox: "0 0 571 465",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.747 106.656L196.519 125.236L120.445 81.1016L153.84 62.5225L228.747 106.656Z",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.747 204.79L196.519 223.374L120.445 179.24L153.84 160.661L228.747 204.79Z",
    stroke: "#231F20",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.559 204.79L196.331 223.374L120.262 179.24L153.651 160.661L228.559 204.79Z",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M196.516 125.235V223.374",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.125 62.5225V160.661L120.477 179.211V81.0723",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M228.746 106.33V204.468",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.244 342.596L396.819 401.648L155.066 261.397L261.181 202.34L499.244 342.596Z",
    fill: "#C1282D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.591 142.917L132.363 161.496L56.2891 117.367L89.6787 98.7832L164.591 142.917Z",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.591 241.056L132.363 259.635L56.2891 215.501L89.6787 196.922L164.591 241.056Z",
    stroke: "#231F20",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.402 241.056L132.174 259.635L56.1055 215.501L89.4951 196.922L164.402 241.056Z",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.359 161.496V259.634",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9687 98.7832V196.922L56.3203 215.471V117.333",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.59 142.595V240.733",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M434.231 155.721L402.003 174.305L325.93 130.171L359.319 111.592L434.231 155.721Z",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M434.231 253.86L402.003 272.444L325.93 228.31L359.319 209.73L434.231 253.86Z",
    stroke: "#231F20",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M434.043 253.86L401.815 272.444L325.746 228.31L359.136 209.73L434.043 253.86Z",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M402 174.305V272.443",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M359.609 111.592V209.73L325.961 228.28V130.142",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M434.23 155.399V253.538",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M534.102 211.092L501.875 229.676L425.801 185.542L459.19 166.958L534.102 211.092Z",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.102 309.231L501.875 327.815L425.801 283.681L459.19 265.097L534.102 309.231Z",
    stroke: "#231F20",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.914 309.231L501.686 327.815L425.617 283.681L459.007 265.097L533.914 309.231Z",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.871 229.676V327.814",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.48 166.958V265.096L425.832 283.646V185.508",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.102 210.77V308.908",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M254.949 89.3507L287.177 107.93L363.251 63.8008L329.861 45.2168L254.949 89.3507Z",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M254.949 187.489L287.177 206.069L363.251 161.939L329.861 143.355L254.949 187.489Z",
    stroke: "#231F20",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M255.133 187.489L287.361 206.069L363.43 161.939L330.04 143.355L255.133 187.489Z",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M287.176 107.93V206.068",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M329.57 45.2168V143.355L363.219 161.905V63.7666",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M254.949 89.0283V187.167",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.023 45.1339L216.251 63.713L292.32 19.584L258.931 1L184.023 45.1339Z",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.023 143.273L216.251 161.852L292.32 117.718L258.931 99.1387L184.023 143.273Z",
    stroke: "#231F20",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.207 143.273L216.435 161.852L292.509 117.718L259.119 99.1387L184.207 143.273Z",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.645 1V99.1383L292.293 117.688V19.5498",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.023 142.945V44.8115L216.251 63.7128V161.851",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.789 346.568L292.017 365.148L368.086 321.019L334.696 302.435L259.789 346.568Z",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.789 444.707L292.017 463.286L368.086 419.152L334.696 400.573L259.789 444.707Z",
    stroke: "#231F20",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.973 444.707L292.201 463.286L368.269 419.152L334.88 400.573L259.973 444.707Z",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.016 365.147V463.286",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.41 302.435V400.573L368.059 419.123V320.984",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.789 346.246V444.38",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M196.516 302.553L228.743 321.137L304.812 277.003L271.423 258.424L196.516 302.553Z",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M196.516 400.691L228.743 419.275L304.812 375.141L271.423 356.557L196.516 400.691Z",
    stroke: "#231F20",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M196.699 400.691L228.932 419.275L305.001 375.141L271.611 356.557L196.699 400.691Z",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M228.742 321.137V419.275",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M271.137 258.424V356.557L304.785 375.107V276.974",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M196.516 302.231V400.37",
    stroke: "white",
    strokeWidth: 1.49375,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6094 261.352V342.844",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5742 253.789V343.951",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5625 268.508V323.991",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M93.543 272.96V318.046",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5664 268.528V332.681",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6875 269.997V351.494",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6445 277.178V341.331",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5312 275.704V312.984",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M72.625 279.779V335.263",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6133 282.742V327.823",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5938 283.246V320.526",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 284.638V297.642",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M105.484 272.237V304.382",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M108.465 269.635V301.78",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4883 283.148V301.352",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M111.453 269.274V301.419",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M117.426 264.485V300.936",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M120.406 255.787V303.47",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M123.391 251.716V308.068",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M114.41 275.221V293.429",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M126.375 257.926V307.342",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M132.348 249.982V298.529",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M135.332 241.694V302.382",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M138.312 252.214V288.664",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M129.336 266.487V287.131",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M141.297 250.759V287.209",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M147.27 246.829V283.275",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M150.254 255.543V273.751",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M153.234 245.369V281.82",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M144.258 257.402V278.046",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M156.969 243.202V279.653",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M162.938 239.272V275.718",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M165.922 237.033V273.484",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M168.902 241.781V267.463",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M159.93 249.1V269.744",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M171.895 240.396V266.077",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M177.863 236.876V262.558",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M180.848 237.623V256.192",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M183.824 231.169V260.483",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M174.852 243.802V258.349",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M186.816 231.975V257.656",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M192.785 228.461V254.143",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M195.766 229.427V244.921",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M198.75 223.247V245.263",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M189.773 235.387V249.934",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M201.734 226.176V243.403",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M207.707 223.271V244.827",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M210.691 223.076V235.28",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M213.672 219.575V234.103",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M204.695 229.085V241.294",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M216.66 218.404V232.927",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M222.629 213.729V235.388",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M225.617 213.729V235.388",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M228.602 210.315V224.364",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M219.617 219.57V231.833",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M231.582 207.114V227.968",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M234.566 204.126V224.98",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M237.555 203.931V224.785",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M240.535 205.547V220.284",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M246.504 204.561V214.094",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M249.492 197.38V218.19",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M252.477 190.325V222.47",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M255.434 196.296V212.708",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M258.449 187.337V219.482",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M243.496 202.44V220.644",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M496.684 302.084V380.013",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M490.715 293.292V379.514",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M487.73 310.123V363.18",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M484.742 312.862V355.971",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M493.727 308.879V370.23",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M511.609 311.616V389.545",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M508.648 316.176V377.527",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M481.766 314.932V350.581",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M505.66 320.154V373.212",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M502.68 322.894V366.002",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M499.695 324.964V360.614",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M475.793 322.146V334.58",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M472.809 312.363V343.102",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M469.82 310.621V341.36",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M478.805 322.146V339.554",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M466.84 308.879V339.618",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M460.867 303.685V338.539",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M457.887 294.619V340.218",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M454.895 289.396V343.284",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M463.883 313.106V330.519",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M451.918 291.057V338.31",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M445.945 287.741V334.165",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M442.965 279.199V337.236",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M439.977 291.271V326.125",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M448.957 302.747V322.488",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M436.996 289.195V324.049",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M431.023 285.438V320.292",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M428.043 295.2V312.613",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M425.055 282.616V317.47",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M434.035 294.839V314.58",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M421.324 276.978V311.832",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M415.355 273.214V308.073",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M412.367 273.214V308.073",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M409.383 275.615V300.174",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M418.363 282.616V302.357",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M322.832 213.454V260.712",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M316.863 209.393V255.821",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M313.883 203.091V261.127",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M310.891 213.669V248.528",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M319.871 226.64V246.381",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M307.91 211.6V246.454",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M301.941 207.088V241.947",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M298.953 214.616V232.029",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M295.969 204.272V239.127",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M304.949 216.491V236.232",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M292.242 203.105V237.96",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M286.277 197.106V231.965",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M283.285 197.106V231.965",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M280.301 199.508V224.067",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M289.277 208.001V227.742",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M406.402 274.293V298.852",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M400.43 271.643V296.202",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M397.449 271.643V289.397",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M394.461 266.184V294.213",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M403.441 278.267V292.174",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M391.477 267.668V292.227",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M385.508 265.018V289.577",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M382.527 263.803V278.618",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M379.535 257.891V278.945",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M388.516 271.643V285.55",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M376.555 260.692V277.168",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M370.586 257.915V278.53",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M367.605 257.729V269.396",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M364.617 254.381V268.274",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M373.598 263.475V275.151",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M361.633 253.258V267.151",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M355.664 248.792V269.499",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M352.68 244.315V265.023",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M349.691 246.272V259.706",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M358.676 254.376V266.106",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M346.707 241.103V261.044",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M343.723 239.609V259.55",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M340.738 237.993V257.939",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M337.758 238.824V252.917",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M331.789 237.911V247.035",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M328.801 229.622V249.519",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M325.816 222.904V253.643",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M334.797 235.758V253.165",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5664 96.3076L570.313 384.44",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "3.7 3.7"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M262.152 201.642L1 346.843",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "3.7 3.7"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M555.388 76.2881L294.23 221.489",
    stroke: "#C1282D",
    strokeWidth: 1.11787,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "3.7 3.7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopSm);
export default __webpack_public_path__ + "static/media/desktop-sm.8baa903f6847125f78a45fb6c3ff28dc.svg";
export { ForwardRef as ReactComponent };